/**
 * King Fahd Causeway Dashboard Translations
 *
 * Arabic/English translation strings for all UI elements.
 * Simple object lookup - no external dependencies.
 */

const translations = {
  // Dashboard Header
  "dashboard.title": {
    ar: "جسر الملك فهد",
    en: "King Fahd Causeway"
  },
  "dashboard.subtitle": {
    ar: "لوحة المعلومات",
    en: "Dashboard"
  },

  // Date Presets
  "datePresets.title": {
    ar: "الفترة الزمنية",
    en: "Time Period"
  },
  "datePresets.today": {
    ar: "اليوم",
    en: "Today"
  },
  "datePresets.last7Days": {
    ar: "آخر 7 أيام",
    en: "Last 7 Days"
  },
  "datePresets.thisMonth": {
    ar: "هذا الشهر",
    en: "This Month"
  },
  "datePresets.lastMonth": {
    ar: "الشهر الماضي",
    en: "Last Month"
  },
  "datePresets.thisQuarter": {
    ar: "هذا الربع",
    en: "This Quarter"
  },
  "datePresets.ytd": {
    ar: "منذ بداية العام",
    en: "Year to Date"
  },
  "datePresets.custom": {
    ar: "نطاق مخصص",
    en: "Custom Range"
  },
  "datePresets.all": {
    ar: "كل البيانات",
    en: "All Data"
  },

  // Settings
  "settings.title": {
    ar: "الإعدادات",
    en: "Settings"
  },
  "settings.itemsPerChart": {
    ar: "عدد العناصر في الرسم البياني",
    en: "Items per chart"
  },
  "settings.language": {
    ar: "اللغة",
    en: "Language"
  },
  "settings.arabic": {
    ar: "العربية",
    en: "Arabic"
  },
  "settings.english": {
    ar: "الإنجليزية",
    en: "English"
  },
  "settings.reset": {
    ar: "استعادة الافتراضي",
    en: "Reset to Defaults"
  },
  "settings.close": {
    ar: "إغلاق",
    en: "Close"
  },
  "settings.autoRefresh": {
    ar: "التحديث التلقائي",
    en: "Auto Refresh"
  },
  "settings.autoRefreshOff": {
    ar: "إيقاف",
    en: "Off"
  },
  "settings.custom": {
    ar: "مخصص",
    en: "Custom"
  },
  "settings.minutes": {
    ar: "دقائق",
    en: "minutes"
  },
  "settings.minInterval": {
    ar: "الحد الأدنى ساعة واحدة",
    en: "Minimum 1 hour"
  },
  "settings.save": {
    ar: "حفظ",
    en: "Save"
  },
  "settings.saving": {
    ar: "جاري الحفظ...",
    en: "Saving..."
  },
  "settings.refreshEvery": {
    ar: "سيتم التحديث كل",
    en: "Will refresh every"
  },

  // Export
  "export.title": {
    ar: "تصدير التقرير",
    en: "Export Report"
  },
  "export.pdf": {
    ar: "تصدير PDF",
    en: "Export PDF"
  },
  "export.selectCharts": {
    ar: "اختر الرسوم البيانية",
    en: "Select Charts"
  },
  "export.selectAll": {
    ar: "تحديد الكل",
    en: "Select All"
  },
  "export.deselectAll": {
    ar: "إلغاء التحديد",
    en: "Deselect All"
  },
  "export.generating": {
    ar: "جاري إنشاء التقرير...",
    en: "Generating report..."
  },
  "export.success": {
    ar: "تم تصدير التقرير بنجاح",
    en: "Report exported successfully"
  },
  "export.error": {
    ar: "فشل في تصدير التقرير",
    en: "Failed to export report"
  },
  "export.cancel": {
    ar: "إلغاء",
    en: "Cancel"
  },

  // Stats
  "stats.totalTransactions": {
    ar: "إجمالي المعاملات",
    en: "Total Transactions"
  },
  "stats.totalTransactionsDesc": {
    ar: "معاملات رسوم المرور في قاعدة البيانات",
    en: "Toll transactions in database"
  },
  "stats.vehicleTypes": {
    ar: "أنواع المركبات",
    en: "Vehicle Types"
  },
  "stats.vehicleTypesDesc": {
    ar: "جميع تصنيفات المركبات مغطاة",
    en: "All vehicle classifications covered"
  },
  "stats.types": {
    ar: "نوع",
    en: "Types"
  },
  "stats.paymentMethods": {
    ar: "طرق الدفع",
    en: "Payment Methods"
  },
  "stats.paymentMethodsDesc": {
    ar: "تغطية كاملة لطرق الدفع",
    en: "Complete payment method coverage"
  },
  "stats.methods": {
    ar: "طريقة",
    en: "Methods"
  },
  "stats.dateCoverage": {
    ar: "تغطية التاريخ",
    en: "Date Coverage"
  },
  "stats.dateCoverageDesc": {
    ar: "إلى",
    en: "to"
  },
  "stats.days": {
    ar: "يوم",
    en: "Days"
  },
  "stats.dateRange": {
    ar: "نطاق البيانات",
    en: "Date Range"
  },

  // Chart Titles
  "chart.vehicleDistribution": {
    ar: "توزيع أنواع المركبات",
    en: "Vehicle Type Distribution"
  },
  "chart.vehicleDistributionDesc": {
    ar: "توزيع المعاملات حسب نوع المركبة",
    en: "Transaction distribution by vehicle type"
  },
  "chart.paymentMethods": {
    ar: "طرق الدفع",
    en: "Payment Methods"
  },
  "chart.paymentMethodsDesc": {
    ar: "توزيع المعاملات حسب طريقة الدفع",
    en: "Transaction distribution by payment method"
  },
  "chart.directionSplit": {
    ar: "توزيع الاتجاهات",
    en: "Direction Distribution"
  },
  "chart.directionSplitDesc": {
    ar: "تقسيم حركة المرور حسب الاتجاه",
    en: "Traffic split by direction"
  },
  "chart.hourlyTraffic": {
    ar: "حركة المرور بالساعة",
    en: "Hourly Traffic"
  },
  "chart.hourlyTrafficDesc": {
    ar: "نمط حركة المرور على مدار الساعة",
    en: "Traffic pattern throughout the day"
  },
  "chart.hourlyVehicleTraffic": {
    ar: "حركة المرور بالساعة حسب نوع المركبة",
    en: "Hourly Traffic by Vehicle Type"
  },
  "chart.vehicleByDirection": {
    ar: "أنواع المركبات حسب الاتجاه",
    en: "Vehicle Types by Direction"
  },
  "chart.dailyTraffic": {
    ar: "حركة المرور اليومية",
    en: "Daily Traffic Trend"
  },
  "chart.dailyTrafficDesc": {
    ar: "اتجاه حجم حركة المرور اليومي",
    en: "Daily traffic volume trend"
  },
  "chart.dailyRevenue": {
    ar: "الإيرادات اليومية",
    en: "Daily Revenue"
  },
  "chart.dailyRevenueDesc": {
    ar: "اتجاه الإيرادات اليومية",
    en: "Daily revenue trend"
  },
  "chart.topBusiestDays": {
    ar: "أكثر الأيام ازدحاماً",
    en: "Top Busiest Days"
  },
  "chart.topBusiestDaysDesc": {
    ar: "الأيام ذات أعلى حجم معاملات",
    en: "Days with highest transaction volume"
  },
  "chart.shiftDistribution": {
    ar: "توزيع الورديات",
    en: "Shift Distribution"
  },
  "chart.shiftDistributionDesc": {
    ar: "توزيع المعاملات حسب الوردية",
    en: "Transaction distribution by shift"
  },
  "chart.laneUsage": {
    ar: "استخدام المسارات",
    en: "Lane Usage"
  },
  "chart.laneUsageDesc": {
    ar: "توزيع حركة المرور حسب المسار",
    en: "Traffic distribution by lane"
  },
  "chart.monthlyComparison": {
    ar: "المقارنة الشهرية",
    en: "Monthly Comparison"
  },
  "chart.monthlyComparisonDesc": {
    ar: "حجم المعاملات حسب الشهر",
    en: "Transaction volume by month"
  },
  "chart.weeklyTrend": {
    ar: "الاتجاه الأسبوعي",
    en: "Weekly Traffic Trend"
  },
  "chart.weeklyTrendDesc": {
    ar: "حجم المعاملات حسب الأسبوع",
    en: "Transaction volume by week"
  },
  "chart.exemptions": {
    ar: "الإعفاءات",
    en: "Exemptions"
  },
  "chart.exemptionsDesc": {
    ar: "توزيع المعاملات المعفاة",
    en: "Exempt transaction distribution"
  },
  "chart.frequentVehicles": {
    ar: "المركبات المتكررة",
    en: "Frequent Vehicles"
  },
  "chart.frequentVehiclesDesc": {
    ar: "المركبات الأكثر تردداً",
    en: "Most frequently crossing vehicles"
  },
  "chart.bidirectionalTravelers": {
    ar: "المسافرين بالاتجاهين",
    en: "Bidirectional Travelers"
  },
  "chart.bidirectionalTravelersDesc": {
    ar: "المسافرين في كلا الاتجاهين",
    en: "Travelers in both directions"
  },
  "chart.dataQualityInsights": {
    ar: "رؤى جودة البيانات",
    en: "Data Quality Insights"
  },
  "chart.dataQualityInsightsDesc": {
    ar: "إحصائيات جودة البيانات ونسب التعرف على اللوحات",
    en: "Data quality statistics and plate recognition rates"
  },
  "chart.noData": {
    ar: "لا توجد بيانات تطابق الفلاتر الحالية",
    en: "No data matches the current filters"
  },

  // Period Comparison
  "comparison.title": {
    ar: "مقارنة الفترات",
    en: "Period Comparison"
  },
  "comparison.currentPeriod": {
    ar: "الفترة الحالية",
    en: "Current Period"
  },
  "comparison.previousPeriod": {
    ar: "الفترة السابقة",
    en: "Previous Period"
  },
  "comparison.transactions": {
    ar: "المعاملات",
    en: "Transactions"
  },
  "comparison.revenue": {
    ar: "الإيرادات",
    en: "Revenue"
  },
  "comparison.change": {
    ar: "التغيير",
    en: "Change"
  },

  // Status
  "status.loading": {
    ar: "جاري التحميل...",
    en: "Loading..."
  },
  "status.error": {
    ar: "حدث خطأ",
    en: "An error occurred"
  },
  "status.noData": {
    ar: "لا توجد بيانات",
    en: "No data available"
  },
  "status.lastUpdated": {
    ar: "آخر تحديث",
    en: "Last Updated"
  },
  "status.syncing": {
    ar: "جاري المزامنة...",
    en: "Syncing..."
  },
  "status.summaryTablesReady": {
    ar: "جداول الملخص جاهزة",
    en: "Summary Tables Ready"
  },
  "status.summaryTablesMissing": {
    ar: "جداول الملخص غير متوفرة",
    en: "Summary Tables Missing"
  },

  // Actions
  "action.refresh": {
    ar: "تحديث",
    en: "Refresh"
  },
  "action.rebuild": {
    ar: "إعادة بناء",
    en: "Rebuild"
  },
  "action.apply": {
    ar: "تطبيق",
    en: "Apply"
  },
  "action.clear": {
    ar: "مسح",
    en: "Clear"
  },

  // Common
  "common.from": {
    ar: "من",
    en: "From"
  },
  "common.to": {
    ar: "إلى",
    en: "To"
  },
  "common.items": {
    ar: "عناصر",
    en: "items"
  },
  "common.of": {
    ar: "من",
    en: "of"
  },
  "common.showing": {
    ar: "يعرض",
    en: "Showing"
  },

  // Feedback System
  "feedback.title": {
    ar: "الإبلاغ عن مشكلة",
    en: "Report Issue"
  },
  "feedback.dashboardTitle": {
    ar: "مشاكل الاستعلامات",
    en: "Query Issues"
  },
  "feedback.dashboardSubtitle": {
    ar: "تتبع ومعالجة المشاكل المُبلغ عنها في الاستعلامات",
    en: "Track and resolve reported query issues"
  },
  "feedback.type.too_slow": {
    ar: "بطيء جداً",
    en: "Too Slow"
  },
  "feedback.type.wrong_answer": {
    ar: "إجابة خاطئة",
    en: "Wrong Answer"
  },
  "feedback.type.could_be_better": {
    ar: "يمكن تحسينها",
    en: "Could Be Better"
  },
  "feedback.type.other": {
    ar: "أخرى",
    en: "Other"
  },
  "feedback.status.open": {
    ar: "مفتوح",
    en: "Open"
  },
  "feedback.status.in_progress": {
    ar: "قيد المعالجة",
    en: "In Progress"
  },
  "feedback.status.resolved": {
    ar: "تم الحل",
    en: "Resolved"
  },
  "feedback.status.wont_fix": {
    ar: "لن يتم الإصلاح",
    en: "Won't Fix"
  },
  "feedback.issueType": {
    ar: "نوع المشكلة",
    en: "Issue Type"
  },
  "feedback.description": {
    ar: "وصف المشكلة",
    en: "Describe the Issue"
  },
  "feedback.descriptionPlaceholder": {
    ar: "اشرح المشكلة بالتفصيل وكيف تتوقع أن يكون الحل...",
    en: "Explain the issue in detail and how you expect it to be solved..."
  },
  "feedback.submit": {
    ar: "إرسال",
    en: "Submit"
  },
  "feedback.submitting": {
    ar: "جاري الإرسال...",
    en: "Submitting..."
  },
  "feedback.success": {
    ar: "تم الإرسال بنجاح!",
    en: "Submitted Successfully!"
  },
  "feedback.successMessage": {
    ar: "شكراً لك! سيتم مراجعة البلاغ قريباً.",
    en: "Thank you! Your report will be reviewed soon."
  },
  "feedback.cancel": {
    ar: "إلغاء",
    en: "Cancel"
  },
  "feedback.reportIssue": {
    ar: "الإبلاغ عن مشكلة",
    en: "Report issue"
  },
  "feedback.reports": {
    ar: "بلاغ",
    en: "report"
  },
  "feedback.noReports": {
    ar: "لا توجد بلاغات",
    en: "No Reports"
  },
  "feedback.noReportsMessage": {
    ar: "لا توجد مشاكل مُبلغ عنها تطابق الفلاتر المحددة",
    en: "No reported issues match the selected filters"
  },
  "feedback.allStatus": {
    ar: "جميع الحالات",
    en: "All Status"
  },
  "feedback.allTypes": {
    ar: "جميع الأنواع",
    en: "All Types"
  },
  "feedback.last7Days": {
    ar: "آخر 7 أيام",
    en: "Last 7 Days"
  },
  "feedback.view": {
    ar: "عرض",
    en: "View"
  },
  "feedback.detail": {
    ar: "تفاصيل البلاغ",
    en: "Report Details"
  },
  "feedback.reporterInfo": {
    ar: "معلومات المُبلِغ",
    en: "Reporter Info"
  },
  "feedback.user": {
    ar: "المستخدم",
    en: "User"
  },
  "feedback.reportDate": {
    ar: "تاريخ البلاغ",
    en: "Report Date"
  },
  "feedback.originalQuestion": {
    ar: "السؤال الأصلي",
    en: "Original Question"
  },
  "feedback.sqlQuery": {
    ar: "استعلام SQL",
    en: "SQL Query"
  },
  "feedback.response": {
    ar: "الرد",
    en: "Response"
  },
  "feedback.resolutionNotes": {
    ar: "ملاحظات الحل",
    en: "Resolution Notes"
  },
  "feedback.resolvedBy": {
    ar: "تم الحل بواسطة",
    en: "Resolved By"
  },
  "feedback.resolvedAt": {
    ar: "تاريخ الحل",
    en: "Resolved At"
  },
  "feedback.updateStatus": {
    ar: "تحديث الحالة",
    en: "Update Status"
  },
  "feedback.resolutionPlaceholder": {
    ar: "أضف ملاحظات حول الحل أو سبب عدم الإصلاح...",
    en: "Add notes about the resolution or reason for not fixing..."
  },
  "feedback.saveChanges": {
    ar: "حفظ التغييرات",
    en: "Save Changes"
  },
  "feedback.updating": {
    ar: "جاري التحديث...",
    en: "Updating..."
  },
  "feedback.previous": {
    ar: "السابق",
    en: "Previous"
  },
  "feedback.next": {
    ar: "التالي",
    en: "Next"
  },
  "feedback.rows": {
    ar: "صف",
    en: "rows"
  }
};

export default translations;
